
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import LoadingSquiggle from './LoadingSquiggle';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  // Dev-only: bypass auth for Figma capture
  const bypassAuth = import.meta.env.DEV && new URLSearchParams(window.location.search).has('bypass-auth');
  if (bypassAuth) {
    return <Outlet />;
  }

  // Show loading state while checking authentication
  if (loading) {
    return <LoadingSquiggle />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Render the protected route if authenticated
  return <Outlet />;
};

export default ProtectedRoute;
